// extracted by mini-css-extract-plugin
export default {"mainContainer":"MainLayout_mainContainer__juPcC","pulse":"MainLayout_pulse__8Y-5d"};